import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Cuenta',
  viewProfile: 'Ver perfil',
  roles: {
    admin: 'Administrador de la plataforma',
    companyAdmin: 'Administrador de la empresa',
    departmentAdmin: 'Administrador/entrenador del departamento',
  },
  company: {
    label: 'Empresa',
    switchTo: 'Cambiar a {{name}}',
  },
  accounts: {
    label: 'Otras cuentas',
    switchTo: 'Cambiar a {{name}}',
    addAnother: 'Iniciar sesión con otra cuenta',
  },
  manage: 'Gestionar',
  settings: 'Perfil de la empresa',
  language: 'Idioma',
  theme: {
    label: 'Tema',
    light: 'Claro',
    dark: 'Oscuro',
    system: 'Sistema',
  },
  signOut: 'Cerrar sesión',
  signOutAll: 'Cerrar sesión en todas las cuentas',
};
